import React from 'react';
import classnames from 'classnames';
import { Trans } from 'react-i18next';
import Flex from '@wix/da-ds/pkg/Flex';
import UserLink from '../../../User/Link/UserLink';
import { useDeviationAttributes } from '../../../DeviationViews/hooks/useDeviationAttributes';
import DeviationFlags from '../../buttons/DeviationFlags';
import BuyButton from '../../buttons/BuyButton';
import ArtShopBuyButton from '../../buttons/ArtShopBuyButton';
import ExpandButton from '../../buttons/ExpandButton';
import { getDeviationTitle } from '../../../DeviationViews/_helpers';
import s from './ExpandActionBar.scss';
var ExpandActionBar = function (_a) {
    var deviation = _a.deviation, author = _a.deviation.author, isOwner = _a.isOwner;
    var _b = useDeviationAttributes(deviation, isOwner), hasFlag = _b.hasFlag, isPrintPurchasable = _b.isPrintPurchasable, isPopupPrintPurchasable = _b.isPopupPrintPurchasable;
    var deviationTitle = getDeviationTitle(deviation);
    var showTitle = !!deviationTitle;
    return (React.createElement(Flex, { className: classnames(s['root'], hasFlag && s['with-badge'], isPrintPurchasable && s['with-print']), justifyContent: "center", alignItems: "center" },
        React.createElement("div", { className: s['badge'] }, hasFlag && React.createElement(DeviationFlags, { deviation: deviation, alwaysExpanded: true })),
        React.createElement("div", { className: s['info'] },
            showTitle && React.createElement("div", { className: s['title'] }, deviationTitle),
            author && (React.createElement("div", { className: s['author'] },
                React.createElement(Trans, { i18nKey: "common.created.byLink" },
                    React.createElement("span", { className: s['by'] }, "By"),
                    " ",
                    React.createElement(UserLink, { user: author }))))),
        React.createElement(Flex, { alignItems: "center", className: s['right-block'] },
            isPrintPurchasable && (React.createElement(BuyButton, { deviation: deviation, className: s['print-button'] })),
            isPopupPrintPurchasable && (React.createElement(ArtShopBuyButton, { deviation: deviation, className: s['print-button'] })),
            React.createElement("div", { className: s['view-switcher'] },
                React.createElement(ExpandButton, { deviation: deviation })))));
};
ExpandActionBar.displayName = 'ExpandActionBar';
export default ExpandActionBar;
//# sourceMappingURL=ExpandActionBar.js.map